"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initClassifiersFeature = initClassifiersFeature;
/* eslint-disable @typescript-eslint/no-explicit-any */
const defineFeature_1 = require("../base/defineFeature");
const defineClassifierHashEntity_1 = require("./entities/defineClassifierHashEntity");
const shared_1 = require("./shared");
const saveClassifierDefaultData_1 = require("./utils/saveClassifierDefaultData");
const saveClassifierPublicData_1 = require("./utils/saveClassifierPublicData");
function initClassifiersFeature(features) {
    const classifiers = {};
    for (const feature of features) {
        if (feature.features?.classifiers?.map) {
            for (const [classifierEntityName, classifier] of Object.entries(feature.features.classifiers.map)) {
                if (!classifiers[classifierEntityName]) {
                    classifiers[classifierEntityName] = classifier;
                }
                else {
                    throw new Error(`Cannot include classifier ${classifierEntityName} from feature ${feature.name} into app because it already exists.`);
                }
            }
        }
    }
    if (Object.keys(classifiers).length > 0) {
        const classifierEntities = {};
        for (const [classifierEntityName, classifier] of Object.entries(classifiers)) {
            classifierEntities[classifierEntityName] = {
                ...classifier.entity,
                onAuthPost: (appState, userState, params, context) => {
                    const entityData = classifier.entity.onAuthPost?.(appState, userState, params, context);
                    if (entityData && params.action !== 'delete') {
                        params = { ...params, data: entityData };
                    }
                    for (const feature of features) {
                        if (feature.features?.classifiers?.onAuthPost) {
                            const entityData = feature.features.classifiers.onAuthPost(appState, userState, params, context);
                            if (entityData && params.action !== 'delete') {
                                params = { ...params, data: entityData };
                            }
                        }
                    }
                },
            };
        }
        return (0, defineFeature_1.defineFeature)({
            name: 'classifiers',
            entities: {
                [shared_1.classifierHashEntityName]: (0, defineClassifierHashEntity_1.defineClassifierHashEntity)(),
                ...classifierEntities,
            },
            onPostDeploy: (context) => {
                for (const feature of features) {
                    if (feature.features?.classifiers?.map) {
                        for (const [entityName, classifier] of Object.entries(feature.features.classifiers.map)) {
                            if (classifier.defaultData) {
                                const defaultData = typeof classifier.defaultData === 'function' ? classifier.defaultData(context) : classifier.defaultData;
                                if (defaultData.length > 0) {
                                    (0, saveClassifierDefaultData_1.saveClassifierDefaultData)(context, entityName, classifier);
                                }
                            }
                            if (classifier.publicData === true) {
                                (0, saveClassifierPublicData_1.saveClassifierPublicData)(context, { entityName: entityName }, false);
                            }
                            else if (Array.isArray(classifier.publicData)) {
                                for (const savePublicDataParams of classifier.publicData) {
                                    (0, saveClassifierPublicData_1.saveClassifierPublicData)(context, { ...savePublicDataParams, entityName: entityName }, false);
                                }
                            }
                            else if (typeof classifier.publicData === 'function') {
                                classifier.publicData(context.storage(entityName), context.publicData, false);
                            }
                        }
                    }
                }
            },
        });
    }
    else {
        return undefined;
    }
}
